export default "__VITE_PUBLIC_ASSET__36ddf94b__"